function stringifyArray(array: string[]): string {
  if (!array?.length) return '';
  if (array.length === 1) return array[0]!;
  if (array.length === 2) return `${array[0]} & ${array[1]}`;

  const lastItem = array[array.length - 1];
  const otherItems = array.slice(0, -1);
  return `${otherItems.join(', ')} & ${lastItem}`;
}

export { stringifyArray };
